exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width:40em){\nform[data-v-7dbfeb85]{align-items:end;display:grid;grid-gap:30px;grid-template-columns:1fr 1fr 100px\n}\nform p[data-v-7dbfeb85],form p input[data-v-7dbfeb85]{margin:0\n}\nform [type=submit][data-v-7dbfeb85]{padding:14px 10px\n}\n}", ""]);

// exports
